<template>
  <div class="content "
       :class="{'loading-overlay loading-overlay-progress': donationsState !== 'ready'}">

    <div class="page-header " :class="{'header-hidden': !isScrollTop}">
      <div class="page-header-img">
        <img :src="require('../../assets/images/home-campaigns.png')" width="200"/>
      </div>
      <div class="page-header-content">
        <div class="page-header-title">
          <div>Tribute Donations</div>
          <p>View donations that were made in Honor/Memory</p>
        </div>

        <div v-if="donationsState === 'ready'">
          <div class="summary-total text-center">
            <span class="fw-900 total-amount">{{statistic.inHonor}}</span>
            <div>In Honor</div>
          </div>
          <div class="summary-total text-center">
            <span class="fw-900 total-amount">{{statistic.inMemory}}</span>
            <div>In Memory</div>
          </div>
          <div class="summary-total text-center">
            <span class="fw-900 total-amount">${{statistic.total/100 | formatMoney}}</span>
            <div>Total Donations</div>
          </div>
        </div>
      </div>
    </div>

    <reports-menu
        :start-date="startDate"
        :end-date="endDate"
        :first-donation-date="firstDonationDate"
        v-on:update-date="updateDate"
        v-on:download="download"
        :isSearchBox="false"
    ></reports-menu>


    <div class="px-8 md:px-4 pt-4 d-reports tab-donations with-header-wrap">
      <div class="d-block shadow-md donations-summary donations-summary-lg">
        <h3 class="title">
          <div class="row">
            <div class="col-sm-6">Tributes</div>
            <div class="col-sm-6 text-right "><span>{{selected(startDate, endDate) | intervalLabel}}</span></div>
          </div>
        </h3>

        <div class="contacts-list campaign-donations-list">
          <div id="c-donations-table_wrapper">

            <el-table
                class="table-extendable"
                :class="{'table-lg-extend': !isScrollTop}"
                style = "width: 100%"
                :default-sort = "sorting"
                :data = "itemsDataPage"
                height="400"
                v-on:sort-change="sortChange"
            >

              <template  slot="empty">
                <div v-if="donationsState === 'ready'" class="empty-placeholder">
                  <img :src="require('../../assets/paceholders/39.svg')" alt="No results">
                  <h3>No Tributes in this Timeframe</h3>
                </div>
                <div v-else slot="empty">Loading data...</div>
              </template>

              <el-table-column label="Name & Date"
                               prop="created_at"
                               sortable="custom"
                               fixed
                               :sort-orders="['descending', 'ascending']"
                               width="220"
              >
                <template slot-scope="scope">
                  <div class="donor">
                    <span class="show-donor-info"
                          v-on:click.prevent="showDonorSidebar(scope.row.uid)"
                    >{{scope.row.first_name}} {{scope.row.last_name}}
                    </span>
                    <div class="info">{{scope.row.created_at | dateFormat('MMM DD, YYYY')}}</div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="Amount & Type"
                               prop="amount"
                               sortable="custom"
                               :sort-orders="['descending', 'ascending']"
                               width="140"
              >
                <template slot-scope="scope">
                  <span class="txt-dark-blue">${{scope.row.amount / 100 | formatMoney(0, 9)}}</span>
                  <div class="info">{{getDonationTypeTitle(scope.row.type)}}</div>
                </template>
              </el-table-column>

              <el-table-column label="Type"
                               prop="metadata.honor.type"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               width="140"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.metadata && scope.row.metadata.honor && scope.row.metadata.honor.type
                  && scope.row.metadata.honor.type.replace(/^\w/, c => c.toUpperCase()) || ''}}
                  </div>
                  <div class="info">Type</div>
                </template>
              </el-table-column>

              <el-table-column label="Honoree"
                               prop="metadata.honor.name"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="200"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.metadata && scope.row.metadata.honor && scope.row.metadata.honor.name || ''}}
                  </div>
                  <div class="info">Honoree</div>
                </template>
              </el-table-column>

              <el-table-column label="From"
                               prop="metadata.honor.from"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="200"
              >
                <template slot-scope="scope">
                  <div>{{scope.row.metadata && scope.row.metadata.honor && scope.row.metadata.honor.from || ''}}
                  </div>
                  <div class="info">From</div>
                </template>
              </el-table-column>

              <el-table-column label="Delivery"
                               prop="metadata.honor.method"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               width="100"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.metadata && scope.row.metadata.honor && scope.row.metadata.honor.method">
                    <div>{{scope.row.metadata.honor.method}}</div>
                    <div class="info">Delivery</div>
                  </div>
                  <div v-else class="info">none</div>
                </template>
              </el-table-column>

              <el-table-column label="Address/Email"
                               prop="address_email"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="240"
              >
                <template slot-scope="scope">
                  <div class="column-text-lines">{{scope.row.address_email}}</div>
                </template>
              </el-table-column>

              <el-table-column label="Message"
                               prop="metadata.honor.message"
                               sortable="custom"
                               :sort-orders="['ascending', 'descending']"
                               min-width="350"
              >
                <template slot-scope="scope">
                  <div class="column-text-lines">{{scope.row.metadata && scope.row.metadata.honor &&
                  scope.row.metadata.honor.message || ''}}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label=""
                               width="75"
              >
                <template slot-scope="scope">

                  <el-dropdown trigger="click" @command="handleCommand">
                      <span class="el-dropdown-link inline-block text-gray-500 text-xl rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200">
                        <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
                      </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="['edit', scope.row]">Edit Tribute</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                </template>
              </el-table-column>


            </el-table>
            <el-pagination
                class="text-right"
                background
                :current-page.sync="currentPage"
                layout="prev, pager, next"
                :page-size="paginationInfo.pageSize"
                :total="itemsData.length">
            </el-pagination>

          </div>

        </div>
      </div>
    </div>


    <donor-info v-if="showDonorInfo"
                :donor-id="showDonorId"
                v-on:close-info="showDonorInfo = false"
    ></donor-info>

    <modal v-if="editModal"
           v-on:close-modal="editModal = false;"
           class="list-modal-wrap"
           :modal-name="'message-turn-off'">

      <div slot="header">
        <div class="info">Edit Tribute</div>
      </div>

      <div slot="body" class="desc">
        <div class="input-control">

          <label class="form-switch">
            <input name="h-type" value="honor" v-model="editParams.type" type="radio">
            <font-awesome-icon :icon="['far', 'star']"/> Honor
          </label>

          <label class="form-switch" style="margin-left: 30px;">
            <input name="h-type" value="memory" v-model="editParams.type" type="radio">
            <font-awesome-icon :icon="['far', 'heart']"/> Memory
          </label>
        </div>
        <div class="input-control form-item">
          <label for="h-name">From</label>
          <input type="text"
                 id="h-from"
                 maxlength="100"
                 v-model="editParams.from"
                 placeholder="From Name"
                 class="input-sm input-chars-limit">
        </div>
        <div class="input-control form-item">
          <label for="h-name">Honoree</label>
          <div class="name">
            <input type="text"
                   id="h-name"
                   maxlength="100"
                   required="required"
                   v-model="editParams.name"
                   placeholder="Honoree Name"
                   class="input-sm input-chars-limit">
          </div>
        </div>

        <div class="input-control">
          <label for="h-message">Message</label>
          <textarea rows="3"
                    id="h-message"
                    v-model="editParams.message"
                    placeholder="Write a message..."
                    class="input-sm list-add-text"
                    style="height: auto;"
          ></textarea>
        </div>
        <div class="input-control">
          <label for="h-method">Delivery</label>
          <select v-model="editParams.method" id="h-method" class="form-control">
            <option value="email"> Email</option>
            <option value="letter"> Letter</option>
            <option :value="null"> None</option>
          </select>
        </div>


        <div v-if="editParams.method === 'email'" class="input-control form-item">
          <div class="name">
            <input type="text"
                   maxlength="100"
                   v-model="editParams.email"
                   required="required"
                   placeholder="Email"
                   class="input-sm input-chars-limit"></div>
        </div>
        <div v-if="editParams.method === 'letter'" class="input-control form-item">
            <textarea rows="3"
                      v-model="editParams.address"
                      placeholder="Address"
                      class="input-sm list-add-text"
                      style="height: auto;"
            ></textarea>
        </div>

      </div>
      <template slot="footer">
        <div>
          <a v-on:click.prevent="editModal = false"
             href="#" class="cancel">Cancel</a>
        </div>
        <div>
          <button type="submit"
                  v-on:click.prevent="editTribute(selectedDonation);editModal = false; "
                  class="btn btn-sm btn-add-to-message"
          >Save Changes
          </button>
        </div>
      </template>
    </modal>

  </div>
</template>

<script>
  import {formatMoney, ucwords} from '@/utils/utils';
  import ReportsMenu from './menu.vue';
  import DonorInfo from '../Parts/DonorInfo.vue';
  import reportsMixin from './reports-mixin';
  import reportsMenuMixin from './reports-menu-mixin';
  import dataTableMixin from '../Parts/data-table-mixin';
  import scrollInfoMixin from '../../mixins/scroll-info-mixin';
  import Modal from '../Modal/index.vue';

  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'Reports',
    mixins: [reportsMixin, reportsMenuMixin, dataTableMixin, scrollInfoMixin],
    components: {
      ReportsMenu,
      DonorInfo,
      Modal,
    },
    metaInfo: {
      title: 'Reports - Donation In Honor/Memory',
    },
    mounted(){
      this.initScrollInfo(['.el-table--scrollable-y','.el-table__body-wrapper', '.content']);
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'edit':
            this.openEditModal(payload)
            break
        }
      },
      sortChange(sorting) {
        this.sorting = sorting
      },
      openEditModal(donationInfo) {

        this.selectedDonation = JSON.parse(JSON.stringify(donationInfo));
        const honorInfo = JSON.parse(JSON.stringify(donationInfo.metadata.honor));

        this.editParams.name = honorInfo.name;
        this.editParams.from = honorInfo.from;
        this.editParams.message = honorInfo.message;
        this.editParams.email = honorInfo.email;
        this.editParams.address = honorInfo.address;
        this.editParams.type = honorInfo.type;
        this.editParams.method = honorInfo.method;

        this.editModal = true;
      },
      editTribute(donationInfo){

        this.$store.dispatch('donations/editDonationNode', {
          charityId: this.activeCharityId,
          donationId: donationInfo.id,
          params: {honor: this.editParams},
        })
            .then(() => {
              this.$message('Donation tribute updated')
            })
            .catch(err => alert(err));
      },
      download(type) {
        const title = `Donation Honor/Memory Reports ${this.period.start.format(
          'MMM D YYYY')} - ${this.period.end.format('MMM D YYYY')}`;

        const header = [
          'First Name', 'Last Name', 'Email', 'Date', 'Time', 'Amount', 'Donation Type',
          'Type', 'Honoree', 'From', 'Delivery', 'Address', 'Email Delivery', 'Message',
        ];

        const body = this.itemsDataSorted.map(item => {

          const dt = moment(item.created_at);
          return [
            item.first_name,
            item.last_name,
            item.email,
            dt.format('MMM D, YYYY'),
            dt.format('h:mma'),
            '$' + formatMoney(item.amount / 100, 2, 9),
            this.getDonationTypeTitle(item.type),
            item.metadata && item.metadata.honor && item.metadata.honor.type && ucwords(item.metadata.honor.type) || '',
            item.metadata && item.metadata.honor && item.metadata.honor.name || '',
            item.metadata && item.metadata.honor && item.metadata.honor.from || '',
            item.metadata && item.metadata.honor && item.metadata.honor.method || '',
            item.metadata && item.metadata.honor && item.metadata.honor.address || '',
            item.metadata && item.metadata.honor && item.metadata.honor.email || '',
            item.metadata && item.metadata.honor && item.metadata.honor.message || '',
          ];
        });

        this.exportData(type, title, header, body);
      },
    },
    computed: {
      ...mapState({
        donations: state => state.donations.donations,
        donationsState: state => state.donations.donationsState,
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      statistic(){
        const donationsData = this.donations.filter(item => item.metadata && item.metadata.honor); // && item.metadata.honor.type

        return {
          inHonor: donationsData.filter(i => i.metadata.honor.type === 'honor').length,
          inMemory: donationsData.filter(i => i.metadata.honor.type === 'memory').length,
          total: donationsData.reduce((res, i) => res + i.amount, 0),
        }
      },
      itemsData() {
        const donationsData = this.donationsData.filter(item => item.metadata && item.metadata.honor);

        return donationsData.map(d => ({
          ...d,
          address_email: (d.metadata && d.metadata.honor)
            ? (d.metadata.honor.address || d.metadata.honor.email || '')
            : '',
        }));
      },
    },
    data() {
      return {
        showDonorInfo: false,
        showDonorId: null,
        editModal: false,

        selectedDonation: null,
        editParams: {
          name: '',
          from: '',
          message: '',
          email: '',
          address: '',
          type: '',
          method: '',
        },

      };
    },
  };
</script>
<style lang="scss">
  .column-text-lines {
    white-space: pre-wrap;
    font-weight: normal !important;
    font-size: 14px;
  }
</style>
